import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "row mb-4" };
const _hoisted_2 = { class: "col-lg-6 col-12" };
const _hoisted_3 = { class: "mb-3" };
const _hoisted_4 = { class: "form-check mb-2" };
const _hoisted_5 = ["value", "id"];
const _hoisted_6 = ["for"];
const _hoisted_7 = { class: "form-floating mb-3" };
const _hoisted_8 = { class: "input-group mb-3" };
const _hoisted_9 = { class: "form-floating" };
const _hoisted_10 = { class: "input-group" };
const _hoisted_11 = { class: "form-floating" };
const _hoisted_12 = { class: "input-group" };
const _hoisted_13 = { class: "form-floating" };
const _hoisted_14 = {
    class: "accordion accordion-flush",
    id: "pricesAccordion"
};
const _hoisted_15 = { class: "accordion-item" };
const _hoisted_16 = {
    id: "color1PricesAccordion",
    class: "accordion-collapse collapse",
    "data-bs-parent": "#pricesAccordion"
};
const _hoisted_17 = { class: "accordion-body" };
const _hoisted_18 = { class: "accordion-item" };
const _hoisted_19 = {
    id: "color2PricesAccordion",
    class: "accordion-collapse collapse",
    "data-bs-parent": "#pricesAccordion"
};
const _hoisted_20 = { class: "accordion-body" };
const _hoisted_21 = { class: "accordion-item" };
const _hoisted_22 = {
    id: "color3PricesAccordion",
    class: "accordion-collapse collapse",
    "data-bs-parent": "#pricesAccordion"
};
const _hoisted_23 = { class: "accordion-body" };
const _hoisted_24 = { class: "accordion-item" };
const _hoisted_25 = {
    id: "color4PricesAccordion",
    class: "accordion-collapse collapse",
    "data-bs-parent": "#pricesAccordion"
};
const _hoisted_26 = { class: "accordion-body" };
const _hoisted_27 = { class: "accordion-item" };
const _hoisted_28 = {
    id: "digitalPricesAccordion",
    class: "accordion-collapse collapse",
    "data-bs-parent": "#pricesAccordion"
};
const _hoisted_29 = { class: "accordion-body" };
const _hoisted_30 = { class: "accordion-item" };
const _hoisted_31 = {
    id: "gravurePricesAccordion",
    class: "accordion-collapse collapse",
    "data-bs-parent": "#pricesAccordion"
};
const _hoisted_32 = { class: "accordion-body" };
import { router } from '@inertiajs/vue3';
import { ref } from 'vue';
import { responseMessages } from '@/Composables/responseMessages';
import ProductPriceOption from '@/Tenant/Components/ProductPriceOption.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PrintArea',
    props: {
        lid: Object,
        printModes: Object
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        const props = __props;
        const emit = __emit;
        const loading = ref(true);
        function update() {
            if (props.lid == null) {
                return;
            }
            router.post(route('admin.lids.printAreas.update', props.lid.uuid), {
                print_area_diameter: props.lid.printAreaDiameter,
                print_area_width: props.lid.printAreaWidth,
                print_area_height: props.lid.printAreaHeight,
                print_mode_ids: props.lid.printModeIds,
                max_colors: props.lid.maxColors
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    emit('update');
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("form", {
                            onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event) => (update()), ["prevent"]))
                        }, [
                            _createElementVNode("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.printModes, (printMode, index) => {
                                    return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            value: printMode.id,
                                            id: 'printMode' + index,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((props.lid.printModeIds) = $event))
                                        }, null, 8, _hoisted_5), [
                                            [_vModelCheckbox, props.lid.printModeIds]
                                        ]),
                                        _createElementVNode("label", {
                                            class: "form-check-label",
                                            for: 'printMode' + index
                                        }, _toDisplayString(printMode.name), 9, _hoisted_6)
                                    ]));
                                }), 256))
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    id: "maxColors",
                                    class: "form-control",
                                    min: "1",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((props.lid.maxColors) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, props.lid.maxColors]
                                ]),
                                _cache[6] || (_cache[6] = _createElementVNode("label", { for: "maxColors" }, "Maximale Farbanzahl", -1))
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        id: "printAreaDiameter",
                                        class: "form-control",
                                        min: "0",
                                        step: "0.01",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((props.lid.printAreaDiameter) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, props.lid.printAreaDiameter]
                                    ]),
                                    _cache[7] || (_cache[7] = _createElementVNode("label", { for: "printAreaDiameter" }, "Druckbereich-Durchmesser", -1))
                                ]),
                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        id: "printAreaWidth",
                                        class: "form-control",
                                        min: "0",
                                        step: "0.01",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((props.lid.printAreaWidth) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, props.lid.printAreaWidth]
                                    ]),
                                    _cache[9] || (_cache[9] = _createElementVNode("label", { for: "printAreaWidth" }, "Druckbereich-Breite", -1))
                                ]),
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                            ]),
                            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "form-text mb-3" }, "Breite des Druckbereichs. Entspricht bei runden Verschlüssen dem Durchmesser des Druckbereichs.", -1)),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        id: "printAreaHeight",
                                        class: "form-control",
                                        min: "0",
                                        step: "0.01",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((props.lid.printAreaHeight) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, props.lid.printAreaHeight]
                                    ]),
                                    _cache[11] || (_cache[11] = _createElementVNode("label", { for: "printAreaHeight" }, "Druckbereich-Höhe", -1))
                                ]),
                                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                            ]),
                            _cache[14] || (_cache[14] = _createStaticVNode("<p class=\"form-text mb-3\">Höhe des Druckbereichs. Entspricht bei runden Verschlüssen dem Durchmesser des Druckbereichs.</p><button type=\"submit\" class=\"btn btn-success d-inline-flex align-items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-check2\" viewBox=\"0 0 16 16\"><path d=\"M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0\"></path></svg><span class=\"ms-2\">Speichern</span></button>", 2))
                        ], 32)
                    ])
                ]),
                _createElementVNode("div", null, [
                    _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Preise", -1)),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "accordion-header" }, [
                                _createElementVNode("button", {
                                    class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                    type: "button",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": "#color1PricesAccordion"
                                }, " 1-farbiger Druck ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                    _createVNode(ProductPriceOption, {
                                        lidPrintArea: props.lid,
                                        colorType: 1,
                                        priceBundleUuid: props.lid.color1PriceBundleUuid
                                    }, null, 8, ["lidPrintArea", "priceBundleUuid"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "accordion-header" }, [
                                _createElementVNode("button", {
                                    class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                    type: "button",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": "#color2PricesAccordion"
                                }, " 2-farbiger Druck ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _createVNode(ProductPriceOption, {
                                        lidPrintArea: props.lid,
                                        colorType: 2,
                                        priceBundleUuid: props.lid.color2PriceBundleUuid
                                    }, null, 8, ["lidPrintArea", "priceBundleUuid"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                            _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "accordion-header" }, [
                                _createElementVNode("button", {
                                    class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                    type: "button",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": "#color3PricesAccordion"
                                }, " 3-farbiger Druck ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createVNode(ProductPriceOption, {
                                        lidPrintArea: props.lid,
                                        colorType: 3,
                                        priceBundleUuid: props.lid.color3PriceBundleUuid
                                    }, null, 8, ["lidPrintArea", "priceBundleUuid"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                            _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "accordion-header" }, [
                                _createElementVNode("button", {
                                    class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                    type: "button",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": "#color4PricesAccordion"
                                }, " 4-farbiger Druck ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                    _createVNode(ProductPriceOption, {
                                        lidPrintArea: props.lid,
                                        colorType: 4,
                                        priceBundleUuid: props.lid.color4PriceBundleUuid
                                    }, null, 8, ["lidPrintArea", "priceBundleUuid"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                            _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "accordion-header" }, [
                                _createElementVNode("button", {
                                    class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                    type: "button",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": "#digitalPricesAccordion"
                                }, " Digital-Druck ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                    _createVNode(ProductPriceOption, {
                                        lidPrintArea: props.lid,
                                        colorType: 0,
                                        priceBundleUuid: props.lid.digitalPriceBundleUuid
                                    }, null, 8, ["lidPrintArea", "priceBundleUuid"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                            _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "accordion-header" }, [
                                _createElementVNode("button", {
                                    class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                    type: "button",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": "#gravurePricesAccordion"
                                }, " Gravur-Druck ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                    _createVNode(ProductPriceOption, {
                                        lidPrintArea: props.lid,
                                        colorType: 11,
                                        priceBundleUuid: props.lid.gravurePriceBundleUuid
                                    }, null, 8, ["lidPrintArea", "priceBundleUuid"])
                                ])
                            ])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
